import { Wand2, Workflow } from 'lucide-react'

import { registerCommands } from '@/components/CommandPalette'

/**
 * Command-palette entries for the Actions page (`Ctrl+K` → "Actions", "World rules"). Registered
 * once, from the route module, through `CommandPalette`'s `registerCommands` registry.
 */

let unregister: (() => void) | null = null

export function registerActionCommands(): () => void {
  if (unregister) return unregister
  const off = registerCommands(({ navigate }) => [
    {
      id: 'go.actions',
      label: 'Actions',
      hint: 'What puppets can do',
      icon: Wand2,
      keywords: 'moves verbs interactions throw catch hug create ai teach',
      run: () => navigate({ to: '/actions', search: {} }),
    },
    {
      id: 'go.rules',
      label: 'World rules',
      hint: 'How the world answers back',
      icon: Workflow,
      keywords: 'rules interactions water splash door world reactions',
      run: () => navigate({ to: '/actions', search: { tab: 'rules' } }),
    },
  ])
  unregister = () => {
    off()
    unregister = null
  }
  return unregister
}
